// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36e709dd","239":"a19f85e1","455":"37d9ea6d"}[chunkId] + ".chunk.js";
};